import { useEffect, useState, type ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Lock } from "@/lib/icons";

const STORAGE_KEY = "elementpad:testing-gate-unlocked";
const PASSWORD = "chemistryelementpad2026";

export default function TestingGate({ children }: { children: ReactNode }) {
  const [unlocked, setUnlocked] = useState<boolean | null>(null);
  const [value, setValue] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    try {
      setUnlocked(localStorage.getItem(STORAGE_KEY) === "1");
    } catch {
      setUnlocked(false);
    }
  }, []);

  if (unlocked === null) return null;
  if (unlocked) return <>{children}</>;

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (value.trim() === PASSWORD) {
      try {
        localStorage.setItem(STORAGE_KEY, "1");
      } catch {
        /* ignore */
      }
      setUnlocked(true);
    } else {
      setError("Incorrect password. Please try again.");
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-4 bg-background">
      <div className="w-full max-w-md rounded-xl border border-border bg-card p-8 shadow-lg">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Lock className="h-6 w-6" aria-hidden="true" />
        </div>
        <h1 className="text-center text-2xl font-bold text-foreground">
          ElementPad is under construction
        </h1>
        <p className="mt-2 text-center text-sm text-muted-foreground">
          This website is currently undergoing construction and testing. Please enter
          the access password to continue.
        </p>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <label htmlFor="testing-gate-password" className="sr-only">
            Access password
          </label>
          <Input
            id="testing-gate-password"
            type="password"
            autoFocus
            autoComplete="current-password"
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              if (error) setError("");
            }}
            placeholder="Enter password"
            aria-invalid={Boolean(error)}
            aria-describedby={error ? "testing-gate-error" : undefined}
          />
          {error && (
            <p
              id="testing-gate-error"
              role="alert"
              className="text-sm text-destructive"
            >
              {error}
            </p>
          )}
          <Button type="submit" className="w-full">
            Enter site
          </Button>
        </form>
      </div>
    </main>
  );
}